import Swiper from "swiper";
import { FreeMode, Scrollbar } from "swiper/modules";
Swiper.use([FreeMode, Scrollbar]);

(function () {
  //   const scrollingAreas = document.querySelectorAll(".mb-scrolling-area");
  const scrollingAreas = document.querySelectorAll(".mb-scrolling-gallery");

  for (let i = 0; i < scrollingAreas.length; i++) {
    let scrollbarConfig = {};

    // scrollbar config
    if (
      scrollingAreas[i].dataset.mbScrollbar &&
      document.getElementById(scrollingAreas[i].dataset.mbScrollbar)
    ) {
      scrollbarConfig = {
        el: "#" + scrollingAreas[i].dataset.mbScrollbar,
        hide: false,
        draggable: true,
      };
    }

    new Swiper(scrollingAreas[i], {
      slidesPerView: "auto",
      freeMode: {
        enabled: true,
      },
      scrollbar: scrollbarConfig,
    });
  }
})();
